import React, { useState, useEffect, useRef } from 'react'
import 'animate.css';
import { FaCube } from "react-icons/fa6";


const BenfitsCards = () => {
    const [isAnimated, setIsAnimated] = useState(false);



    const cardRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {

                    setIsVisible(true);
                }
            },
            { threshold: 0.2 }
        );

        if (cardRef.current) {
            observer.observe(cardRef.current);
        }

        return () => {
            if (cardRef.current) {
                observer.unobserve(cardRef.current);
            }
        };
    }, []);

    return (
        <div className='tf-container'>
            <div className="row">
                <div className="col-12">

                    <div className="widget-tabs style-2 style-border-primary">
                        <div className="widget-content-tab">

                            <div className='widget-content-inner active '>
                                <div className="grid-layout-3">
                                    <div
                                        ref={cardRef}
                                        className={`icons-box default effec-icon ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}
                                    >
                                        <div className="tf-icon text-center">

                                            <svg width="100" height="100" viewBox="0 0 100 100" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6.23437 53.0156H13.2656V93.5469C13.2656 93.9613 13.4302 94.3587 13.7233 94.6517C14.0163 94.9447 14.4137 95.1094 14.8281 95.1094H85.1562C85.5706 95.1094 85.9681 94.9447 86.2611 94.6517C86.5541 94.3587 86.7188 93.9613 86.7188 93.5469V53.0156H93.7969C94.4075 53.0157 95.0043 52.8332 95.5105 52.4916C96.0166 52.1499 96.4091 51.6648 96.6375 51.0984C96.8751 50.521 96.9343 49.8856 96.8073 49.2743C96.6803 48.6629 96.373 48.1037 95.925 47.6687L52.1359 5.73905C51.5551 5.19085 50.7862 4.88613 49.9875 4.88758C49.1888 4.88903 48.421 5.19655 47.8422 5.74686L4.09219 47.6656C3.63982 48.0922 3.32632 48.645 3.19249 49.2522C3.05865 49.8593 3.11068 50.4927 3.34179 51.0699C3.57291 51.6471 3.97241 52.1414 4.48832 52.4884C5.00422 52.8355 5.61263 53.0191 6.23437 53.0156ZM49.9844 8.00311L93.8 49.8906L93.7969 51.4531V49.8906H85.1562C84.7418 49.8906 84.3444 50.0552 84.0514 50.3483C83.7584 50.6413 83.5938 51.0387 83.5938 51.4531V91.9844H16.3906V51.4531C16.3906 51.0387 16.226 50.6413 15.933 50.3483C15.64 50.0552 15.2425 49.8906 14.8281 49.8906L6.25312 49.925L49.9844 8.00311Z"
                                                    fill="#111111" />
                                                <path
                                                    d="M51.3969 67.7188H48.6047C47.6709 67.7171 46.7758 67.3453 46.1156 66.6848C45.4554 66.0244 45.084 65.1291 45.0828 64.1953C45.0828 63.7809 44.9182 63.3835 44.6252 63.0905C44.3321 62.7974 43.9347 62.6328 43.5203 62.6328C43.1059 62.6328 42.7085 62.7974 42.4155 63.0905C42.1224 63.3835 41.9578 63.7809 41.9578 64.1953C41.961 65.9279 42.6405 67.5909 43.8517 68.8298C45.063 70.0687 46.7101 70.7858 48.4422 70.8281V73.9062C48.4422 74.3207 48.6068 74.7181 48.8998 75.0111C49.1929 75.3041 49.5903 75.4688 50.0047 75.4688C50.4191 75.4688 50.8165 75.3041 51.1095 75.0111C51.4026 74.7181 51.5672 74.3207 51.5672 73.9062V70.8281C53.2982 70.7842 54.9437 70.0664 56.1536 68.8277C57.3635 67.5889 58.0422 65.9269 58.0453 64.1953C58.0432 62.4327 57.3421 60.7428 56.0957 59.4964C54.8494 58.2501 53.1595 57.5489 51.3969 57.5469H48.6047C47.6709 57.5452 46.7758 57.1734 46.1156 56.513C45.4554 55.8525 45.084 54.9573 45.0828 54.0234C45.084 53.0896 45.4554 52.1944 46.1156 51.5339C46.7758 50.8735 47.6709 50.5017 48.6047 50.5H49.9797C49.9891 50.5 49.9953 50.5047 50.0062 50.5047C50.0172 50.5047 50.0219 50.5 50.0328 50.5H51.3969C52.331 50.5012 53.2264 50.8729 53.8869 51.5334C54.5475 52.1939 54.9191 53.0893 54.9203 54.0234C54.9203 54.4378 55.0849 54.8353 55.378 55.1283C55.671 55.4213 56.0684 55.5859 56.4828 55.5859C56.8972 55.5859 57.2946 55.4213 57.5877 55.1283C57.8807 54.8353 58.0453 54.4378 58.0453 54.0234C58.0418 52.2924 57.3631 50.631 56.1536 49.3926C54.9441 48.1542 53.2992 47.4365 51.5687 47.3922V44.3203C51.5687 43.9059 51.4041 43.5085 51.1111 43.2155C50.8181 42.9224 50.4206 42.7578 50.0062 42.7578C49.5918 42.7578 49.1944 42.9224 48.9014 43.2155C48.6084 43.5085 48.4437 43.9059 48.4437 44.3203V47.3906C46.7114 47.4326 45.0638 48.1494 43.8523 49.3884C42.6408 50.6274 41.961 52.2905 41.9578 54.0234C41.9599 55.7858 42.6608 57.4754 43.9068 58.7218C45.1529 59.9681 46.8423 60.6694 48.6047 60.6719H51.3969C52.331 60.6731 53.2264 61.0447 53.8869 61.7052C54.5475 62.3657 54.9191 63.2612 54.9203 64.1953C54.9191 65.1294 54.5475 66.0249 53.8869 66.6854C53.2264 67.3459 52.331 67.7175 51.3969 67.7188Z"
                                                    fill="#FF6300" />
                                                <path
                                                    d="M50.0063 84.3656C63.9328 84.3656 75.2609 73.0359 75.2609 59.1094C75.2609 45.1828 63.9328 33.8547 50.0063 33.8547C36.0797 33.8547 24.75 45.1828 24.75 59.1094C24.75 73.0359 36.0797 84.3656 50.0063 84.3656ZM50.0063 36.9797C62.2094 36.9797 72.1359 46.9062 72.1359 59.1094C72.1359 71.3125 62.2078 81.2406 50.0063 81.2406C37.8031 81.2406 27.875 71.3125 27.875 59.1094C27.875 46.9062 37.8031 36.9797 50.0063 36.9797Z"
                                                    fill="#FF6300" />
                                            </svg>
                                        
                                        </div>
                                        <h3 className="title text-center text-h4"><a href="#">Cost-Effective Investment for Everyone </a></h3>
                                        <p className="text-center text-1">Lower your financial barrier to entry</p>

                                    </div>

                                    <div
                                        ref={cardRef}
                                        className={`icons-box default effec-icon ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}
                                    >
                                        <div className="tf-icon text-center">
                                        <svg width="100" height="100" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  
                                        <path d="M10 50 A40 40 0 0 1 90 50" stroke="#111111" strokeWidth="6" fill="none"/>
                                        
                                        <line x1="50" y1="50" x2="20" y2="20" stroke="#FF6300" strokeWidth="6" strokeLinecap="round"/>

                                        <circle cx="50" cy="50" r="5" fill="#FF6300"/>

                                        <text x="5" y="60" fontSize="12" fill="#111111">Low</text>
                                        <text x="70" y="58" fontSize="12" fill="#111111">High</text>
                                        </svg>

                                        </div>
                                        <h3 className="title text-center text-h4"><a href="#">Diversified Portfolio for Reduced Risk </a></h3>
                                        <p className="text-center text-1">Invest in multiple properties with ease. </p>

                                    </div>
                                    <div
                                        ref={cardRef}
                                        className={`icons-box default effec-icon ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}
                                    >
                                        <div className="tf-icon text-center">
                                        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
   
                                            <path 
                                                d="M50 10L20 25V45C20 70 35 85 50 90C65 85 80 70 80 45V25L50 10Z" 
                                                stroke="#111111" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"
                                            />

                                            <path 
                                                d="M35 50L45 60L65 40" 
                                                stroke="#FF6300" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none"
                                            />
                                        </svg>
                                          
                                        </div>
                                        <h3 className="title text-center text-h4"><a href="#">Hassle-Free Management for Peace of Mind </a></h3>
                                        <p className="text-center text-1">Enjoy your investment without the headaches</p>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>


    )
}

export default BenfitsCards